// Round 1, lane C — the answer economy rule (docs/briefs/ROUND1-SPEC-2026-09-05.md section F.5)
// and the one column ceiling Round 1 enforces (section F.6). The rule is the client's own
// (editor-client AnswerForm.js:173-192: price 0 → the passive type; a price on a passive type → the
// active/paid type) with the ids from AnswerStep.ts:11-16 (Free = 4, Paid = 6) and Addendum 1 A.5.
// ep02 agrees: 88 answers of type 4 at price 0, 2 answers of type 6 at a price above 0. The seed
// values of the AnswerTypes table are not in the vendor tree (section L); Round 1 uses the ids only.

/** AnswerStep.ts:11-16 — the Free (passive) answer type. */
export const ANSWER_TYPE_FREE = 4;

/** AnswerStep.ts:11-16 — the Paid (active) answer type. */
export const ANSWER_TYPE_PAID = 6;

/**
 * F.6: Steps.text, Answers.text, HubOptions.title, Branches.title and Branches.description are
 * VARCHAR(255) (Addendum 2, correction 4: the settings caps are client-side and Round 3 reads them).
 */
export const TEXT_COLUMN_LIMIT = 255;

/**
 * The answer type that follows a price. `price === 0` → Free (4); a price above 0 on a Free answer
 * (or on an answer with no type yet) → Paid (6); any other type (2 Erotic, 3 Romantic) keeps its
 * type when priced. A price that is not above zero (0, a negative number the planner refuses
 * anyway, NaN) reads as free.
 */
export function answerTypeForPrice(price: number, current: number | null | undefined): number {
  if (!(Number(price) > 0)) return ANSWER_TYPE_FREE;
  if (current === null || current === undefined || Number(current) === ANSWER_TYPE_FREE) return ANSWER_TYPE_PAID;
  return Number(current);
}
